module.exports = __webpack_public_path__ + "img/master_archer_small.ac68e092.png";